import React, { useEffect } from "react";
import "./FAQ.css";
import { Accordion, Container, Row, Col } from "react-bootstrap";
import Common_Title from "../../common/common-title/Common_Title";
import { useDispatch, useSelector } from "react-redux";
import { GetAllfaq } from "../../../redux/aboutus";

const FAQ = ({ faq }) => {
  // const dispatch = useDispatch();
  // const faq = useSelector((state) => state?.aboutus?.faq);
 
  // useEffect(() => {
  //   dispatch(GetAllfaq());
  // }, [dispatch]);

  return (
    <section className="FAQ_div">
      <div className="container">
        <div className="FAQ_header">
          <Common_Title title="FREQUENTLY ASKED QUESTIONS " />
        </div>

        <div className="FAQ_section">
          <Accordion defaultActiveKey="0">
            {faq?.map((item, index) => (
              <Accordion.Item
                eventKey={index.toString()}
                key={item?.id}
                className="mb-3"
              >
                <Accordion.Header>
                  <span className="faq_number">{index + 1}</span>
                  <span className="faq_question">{item?.questions}</span>
                </Accordion.Header>
                <Accordion.Body>{item?.answers}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
